import React from "react";
// core components
import { Col, Row } from 'reactstrap';

import uniqBy from 'lodash/uniqBy';

import { IoMdCheckmark, IoMdRemove, IoIosSearch } from 'react-icons/io'
import { FaFileUpload, FaFolderPlus } from 'react-icons/fa';
import { connect } from 'react-redux'
import PropTypes from "prop-types";
import { bindActionCreators }  from 'redux';
import queryString from 'query-string';

import RightSidebar from '../RightSidebar';

import commonStyle from "commonStyle";

import { formatter } from "utils";

import Button from "components/Button";
import Spacer from "components/Spacer";
import ScrollView from 'components/ScrollView';

import { getObjects, getObjectDownload } from "api/actions";

import { withoutAuth, withSearch } from "HOC"

import {
  GET_OBJECTS,
  GET_OBJECTS_SUCCESS,
  GET_OBJECTS_FAILURE,
  UNSTAR_OBJECT_SUCCESS
} from '../../../constants/ActionTypes'

import './index.css'
import TruncateLine from "components/TruncateLine";

import TableRow from 'components/TableRow';


export default class MainView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      hoveringOver: null,
      page: 0,
      selections: [],
      loading: false,
    };
  }

  async componentWillReceiveProps(props) {
    const refresh = this.state.search !== props.location.search;

    if (props.hasOwnProperty('objects')) {
      await this.addObjects(props.objects);
    }

    const newState = {
      loading: props.loading,
      page: props.objects.length > 0 ? this.state.page + 1 : this.state.page
    };

    if (refresh) {
      newState.data = [];
      newState.search = props.location.search;
      newState.page = 0;
    }

    switch(props.type) {
      case UNSTAR_OBJECT_SUCCESS:
        await this.removeItem(props.unstarredKey);
        break;
    }

    this.setState(newState, () => {
      if (refresh) {
        const prefix = props.location.search ? queryString.parse(props.location.search).prefix : '';
        this.fetchMore(0, { prefix });
      }
    });
  }

  componentWillMount() {
    const { page } = this.state;

    const prefix = this.props.location.search ? queryString.parse(this.props.location.search).prefix : '';
    this.setState({
      search: this.props.location.search,
      data: [],

    });
    this.props.getObjects({ page, prefix });
  }

  addObjects = (objects = []) => new Promise((resolve) => {
    if (objects.length > 0) {
      let objs = this.state.data;

      objs = objs.concat(objects);
      objs = uniqBy(objs, info => info.id);

      this.setState({
        data: objs,
      }, resolve);
    } else {
      resolve();
    }
  });

  removeItem  = (id) => new Promise((resolve) => {
    this.setState({
        data: this.state.data.filter(data => data.id !== id),
      }, resolve);
  });

  fetchMore = (page, options = {}) => {
    if (!this.state.loading) {
      const prefix = this.props.location.search ? queryString.parse(this.props.location.search).prefix : '';
      this.props.getObjects({ page, prefix: options.prefix || prefix });
    }
  };

  updateSelections = updatedSelections => new Promise(resolve => {
    this.setState({
      selections: updatedSelections
    }, () => {
      const { onSelectionsUpdate } = this.props;

      onSelectionsUpdate && onSelectionsUpdate();

      resolve();
    })
  });

  renderNoData = () => {
    if (this.props.loading) {
      return null;
    } else {
      return (
        <div className={'empty-bucket'}>
          <h3>No starred files or folders</h3>
          <p>Star files on your dashboard and view them here</p>
        </div>
      )
    }
  }

  renderTable = ({ data, oneSelected, multipleSelected, allSelected }) => (
    <table
      style={{
        width: '100%',
      }}
    >
      <thead>
        <tr
          onMouseOver={() => {
            this.setState({
              hoveringOver: 'rowHead'
            })
          }}
          onMouseLeave={() => {
            this.setState({
              hoveringOver: null
            })
          }}
        >
          <td>
            <p className={'tableHead'}>Name</p>
          </td>
          <td>
            <p className={'tableHead'}>Last Modified</p>
          </td>
          <td>
            <p className={'tableHead'}>Size</p>
          </td>
        </tr>
      </thead>
      <tbody>
      {
        data.map(info => {
          const { id, starred } = info;
          const isSelected = this.state.selections.indexOf(id) !== -1;
          const isStarred = starred;

          return (
            <TableRow
              key={info.id}
              onMouseOver={() => {
                this.setState({
                  hoveringOver: id
                })
              }}
              onMouseLeave={() => {
                this.setState({
                  hoveringOver: null
                })
              }}
              onCheckbox={async () => {
                let _selections = this.state.selections;

                const containsItem = _selections.includes(id);

                if (containsItem) {
                  _selections.splice(_selections.indexOf(id), 1);
                } else {
                  _selections.push(id);
                }

                await this.updateSelections(_selections);
                this.forceUpdate()
              }}
              onSelect={async () => {
                await this.updateSelections([id]);
              }}
              isStarred={isStarred}
              isSelected={isSelected}
              onView={() => {
                this.props.showPreview && this.props.showPreview(id)
              }}
              canSelect={false}
              {...info}
            />
          )
        })
      }
      </tbody>
    </table>
  )

  render() {
    const { data } = this.state;

    const hasData = data.length > 0;

    const oneSelected = this.state.selections.length === 1;
    const multipleSelected = this.state.selections.length > 1;
    const allSelected = this.state.selections.length === this.state.data.length;



    return (
      <div style={{ paddingLeft: 10, paddingTop: 15, height: '100%' }}>
        <Row style={{ height: '100%' }}>
          <Col
            xs={12}
            sm={12}
            md={12}
          >
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
              }}
            >
              <ScrollView
                gap={0.5}
                onBottom={() => {
                  const { page } = this.state;

                  this.fetchMore(page);
                }}
                className={'table-col'}
              >
                {hasData ?
                  this.renderTable({ data, oneSelected, multipleSelected, allSelected })
                  :
                  this.renderNoData()
                }
              </ScrollView>
            </div>
          </Col>
          <div className={`loader-container ${this.props.loading ? 'loading-show' : 'loading-hide'}`}>
            <div className="loader"></div>
          </div>
        </Row>
      </div>
    );
  }
}

MainView.defaultProps = {
  objects: []
};